// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"table-with-loading_tableContainer__1j1kM","table":"table-with-loading_table__3IK7T","tableHeader":"table-with-loading_tableHeader__2pF4N"};